export default {
	name: "SideContentBlock",
	data() {
		return {
		}
	},
	props: [
		"title",
		"color",
		"dataColor",
		"index",
		"last",
		"openIndex",
	],
	created() {},
	watch: {},
	computed: {},
	methods: {}
}



// WEBPACK FOOTER //
// ./src/components/blocks/sidecontent/sidecontent.block.js